module.exports = __webpack_public_path__ + "static/company-logo-b35c88032b9cde567c56b64c2ed036ed.png";